module.exports = __webpack_public_path__ + "img/mirabeau.742bae7e.jpg";